import script from "./BOM.vue?vue&type=script&setup=true&lang=js"
export * from "./BOM.vue?vue&type=script&setup=true&lang=js"

import "./BOM.vue?vue&type=style&index=0&id=246fe933&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246fe933"]])

export default __exports__